import colors from 'src/style-utils/colors';
import { Flex } from 'src/style/flexbox.style';
import styled from 'styled-components';

export const LastSentContainer = styled(Flex)`
  background-color: white;
  border-radius: 0.4rem;
  color: ${colors.textColorBlack};
`;
